import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Button} from '@nl/component';
import {useI18n} from '@nl/i18n';

import '../../styles/modal/verticalcentermodal.scss';

function VerticalCenteredModal(props) {
	const {id, onClose, show, onHide, onCustom} = props;
	const [headerTitle, bodyTitle, btnCustom, btnClose] = useI18n([
		`${id}_header_title`,
		`${id}_body_title`,
		`${id}_custom`,
		`${id}_close`], {
		keyPrefix: 'modal_',
	});
	const [bodyDesc] = useI18n(`modal_${id}_body_description`, {isHTML: true});
	return (
			<Modal
					show={show}
					onHide={onHide}
					size="lg"
					aria-labelledby="contained-modal-title-vcenter"
					centered
			>
				{
					headerTitle && (
							<Modal.Header closeButton={onClose !== undefined}>
								<Modal.Title id="contained-modal-title-vcenter">
									{headerTitle}
								</Modal.Title>
							</Modal.Header>
					)
				}
				<Modal.Body>
					{
						bodyTitle && <h4>{bodyTitle}</h4>
					}
					<p>{bodyDesc}</p>
				</Modal.Body>
				<Modal.Footer>
					{onCustom && <Button onClick={() => onCustom()}>{btnCustom}</Button>}
					{onClose && <Button onClick={() => onClose()}>{btnClose}</Button>}
				</Modal.Footer>
			</Modal>
	);
}

VerticalCenteredModal.defaultProps = {
	onClose: null,
	onCustom: null,
	onHide: null,
};

VerticalCenteredModal.propTypes = {
	show: PropTypes.bool.isRequired,
	id: PropTypes.string.isRequired,
	onClose: PropTypes.func,
	onCustom: PropTypes.func,
	onHide: PropTypes.func,
};

export default VerticalCenteredModal;
